<div class="modal-header">
  <h4 class="modal-title" id="drg-selector-title">Select MS-DRG</h4>
  <button mat-icon-button type="button" class="ms-auto" aria-label="Close" (click)="activeModal.dismiss(null)">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <stg-ngx-ag-grid height="400px"
                   [gridOptions]="gridOptions"
                   (onGridReady)="onGridReady($event)"
                   (onFirstDataRendered)="onFirstDataRendered()"
                   (onRowSelected)="rowSelected($event)">
  </stg-ngx-ag-grid>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close(null)">Cancel</button>&nbsp;&nbsp;
  <button type="button" class="btn btn-primary" (click)="saveData()" [disabled]="saveDisabled">Save</button>
</div>
